module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/66.9f8b63a8.png";